import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

const LanguageToggle = ({ variant = 'default' }) => {
  const { language, setLanguage } = useLanguage();

  if (variant === 'minimal') {
    return (
      <div className="inline-flex items-center rounded-md border border-white/15 p-0.5 bg-[#1A2231] shadow-sm">
        <button
          onClick={() => setLanguage('de')}
          className={`px-3 py-1.5 text-xs font-semibold mono rounded transition-colors ${
            language === 'de'
              ? 'bg-[#4A8FD1] text-white shadow-inner'
              : 'text-slate-400 hover:text-slate-50 hover:bg-white/10'
          }`}
          aria-label="Auf Deutsch wechseln"
          aria-pressed={language === 'de'}
        >
          DE
        </button>
        <span className="text-slate-300 text-xs px-0.5" aria-hidden="true">|</span>
        <button
          onClick={() => setLanguage('en')}
          className={`px-3 py-1.5 text-xs font-semibold mono rounded transition-colors ${
            language === 'en'
              ? 'bg-[#4A8FD1] text-white shadow-inner'
              : 'text-slate-400 hover:text-slate-50 hover:bg-white/10'
          }`}
          aria-label="Switch to English"
          aria-pressed={language === 'en'}
        >
          EN
        </button>
      </div>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}
      className="mono text-xs"
    >
      {language === 'en' ? 'EN / DE' : 'DE / EN'}
    </Button>
  );
};

export default LanguageToggle;
